import React, { useEffect } from 'react';

import Avatar, { AvatarType, Size } from '@rover/components/src/Avatar/Avatar';
import { Flex, Text } from '@rover/kibble/core';
import type { Image } from '@rover/rsdk/src/apiClient/latest/model/image';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { TrainingMethodologyModalLoads } from '../../../events/analyticsEvents';

type MethodologyDetailsModalProps = {
  methodology: string;
  methodologyDetails: string;
  shortName: string;
  defaultImage: Image;
};
const MethodologyDetailsModal: React.FC<MethodologyDetailsModalProps> = ({
  methodology,
  methodologyDetails,
  shortName,
  defaultImage,
}) => {
  useEffect(() => {
    // Note: This modal was replaced, but Product requested to keep using the same event.
    emitAnalyticsEvent(new TrainingMethodologyModalLoads());
  }, []);

  return (
    <Flex flexDirection="column" alignContent="flex-start" gap="4x" marginBottom="8x">
      <Flex alignItems="center" gap="2x" justifyContent="flex-start">
        <Avatar
          diameter={24}
          size={Size.Profile}
          borderRadius="50%"
          avatarType={AvatarType.Person}
          imageUrl={defaultImage.medium}
        />
        <Text size="100" sx={{ fontWeight: '600', 'white-space': 'nowrap' }}>
          {shortName}
        </Text>
      </Flex>
      <Text textAlign="left" size="300" sx={{ fontWeight: '600' }}>
        {methodology}
      </Text>
      <Flex flexDirection="column">
        <Text size="200">{methodologyDetails}</Text>
      </Flex>
    </Flex>
  );
};

export default MethodologyDetailsModal;
